import { Dispatch, FC, MouseEvent, SetStateAction } from "react";
import styled from "styled-components";

import { ImportType } from "./";
import Button from "@/components/Button";

const StyledButton = styled(Button)`
  font-weight: 600;
  &:hover,
  &:active {
    border-color: ${({ theme }) => theme.colors.purple};
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

interface Props {
  importTypes: ImportType[];
  setImportType: Dispatch<SetStateAction<ImportType | null>>;
}

const UploadTypeSelection: FC<Props> = ({ importTypes, setImportType }) => {
  const onClick = (e: MouseEvent<HTMLButtonElement>, type: ImportType) => {
    e.stopPropagation();

    setImportType(type);
  };

  return (
    <List>
      {importTypes.map((type, index) => (
        <StyledButton
          type="button"
          color="secondary"
          key={index}
          onClick={(e: MouseEvent<HTMLButtonElement>) => onClick(e, type)}
        >
          {type.title}
        </StyledButton>
      ))}
    </List>
  );
};

export default UploadTypeSelection;
